// Shared placement metadata and the data shape used by the listing impressions
// chart and the funnel's Impressions / Listing-views steps. The data itself is
// real GA4, built in useListingImpressions:
//  - impressions  → `view_item_list` events, split by `item_list_id` placement.
//  - listing views → `view_item` events, split by traffic-source channel. GA4's
//    native `view_item` carries no `item_list_id`, so the datawarehouse flow
//    repurposes that column to carry the event's `source|medium`, which we map
//    to a friendly channel here.
export type PlacementKey =
  | 'search_results'
  | 'similar_listings'
  | 'agency_profile'
  | 'landing_page'
  | 'other';

export const PLACEMENTS: { key: PlacementKey; color: string }[] = [
  { key: 'search_results', color: '#4285f4' },
  { key: 'similar_listings', color: '#00897b' },
  { key: 'agency_profile', color: '#5e35b1' },
  { key: 'landing_page', color: '#e8710a' },
  { key: 'other', color: '#80868b' },
];

// Traffic-source channels for the listing-views breakdown, in stacking / legend
// order.
export type ViewChannelKey =
  | 'organic'
  | 'paid'
  | 'email'
  | 'social'
  | 'referral'
  | 'ai'
  | 'direct'
  | 'other';

export const VIEW_CHANNELS: { key: ViewChannelKey; color: string }[] = [
  { key: 'organic', color: '#4285f4' },
  { key: 'paid', color: '#e8710a' },
  { key: 'email', color: '#00897b' },
  { key: 'social', color: '#5e35b1' },
  { key: 'referral', color: '#f9ab00' },
  { key: 'ai', color: '#9334e6' },
  { key: 'direct', color: '#c2185b' },
  { key: 'other', color: '#80868b' },
];

export type ImpressionsSeries = {
  labels: string[];
  // Impressions per placement, per bucket.
  barSeries: { key: PlacementKey; color: string; data: number[] }[];
  // Listing views per channel, per bucket.
  viewsSeries: { key: ViewChannelKey; color: string; data: number[] }[];
  // Listing views per bucket (all channels summed).
  viewsTotal: number[];
  totalImpressions: number;
  totalViews: number;
};
